<template>
  <div id="Builder" :class="{ fullscreen: mode == 'fullscreen' }">
    <div class="side_bar" v-if="mode != 'fullscreen'">
      <div class="brand">Webpage Builder</div>
      <div class="config">
        <div class="section">
          <div class="title">Page</div>
          <div class="page_name">
            <input
              type="text"
              :value="get_page_name"
              @input="update_page_name"
              @blur="check_page_name"
            />
          </div>
          <div class="actions">
            <button @click="add_component('header', 'Header_1')">Header</button>
            <button @click="add_component('home', 'Home_1')">Home</button>
            <button @click="add_component('sections', 'Section_1')">
              Section
            </button>
            <button @click="add_component('footer', 'Footer_1')">Footer</button>
          </div>
        </div>
        <div class="section">
          <div class="title">Options</div>
          <div class="options">
            <div v-for="(item, index) of get_options" :key="index">
              <input type="text" v-model="get_options[index]" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="workspace" :class="mode">
      <div class="cmp_list active" v-if="cmp_list == true">
        <div>
        <div class="list_header">TEST</div>
        <div class="list_content"></div>
        </div>
      </div>
      <div class="header">
        <div class="project_title">Some project name</div>
        <div class="menu">
          <div class="toggles">
            <button
              :class="{ active: mode == 'desktop' }"
              @click="mode = 'desktop'"
            >
              <ion-icon name="desktop-outline"></ion-icon>
            </button>
            <button
              :class="{ active: mode == 'tablet' }"
              @click="mode = 'tablet'"
            >
              <ion-icon name="tablet-portrait-outline"></ion-icon>
            </button>
            <button
              :class="{ active: mode == 'mobile' }"
              @click="mode = 'mobile'"
            >
              <ion-icon name="phone-portrait-outline"></ion-icon>
            </button>
            <button
              :class="{ active: mode == 'fullscreen' }"
              @click="mode = 'fullscreen'"
            >
              <ion-icon name="expand-outline"></ion-icon>
            </button>
          </div>
          <div class="main">
            <button class="settings">
              <ion-icon name="settings-outline"></ion-icon>
            </button>
            <button class="export">
              Export
              <ion-icon name="download-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="board can_hide_options" @click="hide_options">
        <div class="navigator">
          <!-- For - Page header -->
          <div
            class="item"
            v-for="page of get_pages"
            :key="page.P_ID"
            :class="{ active: get_active_page == page.P_ID }"
            @click="make_page_active(page.P_ID)"
          >
            <div>{{ page.name }}</div>
            <button class="menu">
              <ion-icon name="ellipsis-vertical"></ion-icon>
            </button>
          </div>
          <div class="add">
            <button @click="add_page()" v-if="allow_page_add == true">
              <ion-icon name="add-outline"></ion-icon>
            </button>
          </div>
        </div>
        <div class="content can_hide_options">
          <div>
            <!-- For - Pages -->
            <div
              id="WB"
              v-for="page of get_pages"
              :key="page.P_ID"
              :class="{
                active: get_active_page == page.P_ID,
                empty: check_if_empty && get_active_page == page.P_ID,
              }"
            >
              <div class="WB_header">
                <!-- Header -->
                <div
                  v-for="header in page.components.header"
                  :key="header.name"
                  :class="{
                    component_active:
                      get_active_component_type == 'header' &&
                      get_active_component_code == header.C_ID,
                  }"
                >
                  <component
                    :is="header.name"
                    :data="header.data"
                    @click="make_component_active('header', header.C_ID)"
                  />
                </div>
              </div>
              <div class="WB_home">
                <!-- Home -->
                <div
                  v-for="home in page.components.home"
                  :key="home.name"
                  :class="{
                    component_active:
                      get_active_component_type == 'home' &&
                      get_active_component_code == home.C_ID,
                  }"
                >
                  <component
                    :is="home.name"
                    :data="home.data"
                    @click="make_component_active('home', home.C_ID)"
                  />
                </div>
              </div>
              <div class="WB_sections">
                <!-- For - sections -->
                <div
                  v-for="section in page.components.sections"
                  :key="section.name"
                  :class="{
                    component_active:
                      get_active_component_type == 'sections' &&
                      get_active_component_code == section.C_ID,
                  }"
                >
                  <!-- Section -->
                  <component
                    :is="section.name"
                    :data="section.data"
                    @click="make_component_active('sections', section.C_ID)"
                  />
                </div>
              </div>
              <div class="WB_footer">
                <!-- Footer -->
                <div
                  v-for="footer in page.components.footer"
                  :key="footer.name"
                  :class="{
                    component_active:
                      get_active_component_type == 'footer' &&
                      get_active_component_code == footer.C_ID,
                  }"
                >
                  <!-- Section -->
                  <component
                    :is="footer.name"
                    :data="footer.data"
                    @click="make_component_active('footer', footer.C_ID)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--**** DEBUGGER *****-->
    <!-- <div style="white-space: pre-wrap">
      {{ state_logger }}
    </div> -->
    <!--**** DEBUGGER *****-->
  </div>
</template>

<script>
import store from "../store/";
import { component_list } from "../components/map.js";

export default {
  name: "Builder",
  components: component_list,
  store: store,
  data() {
    return {
      mode: "desktop",
      cmp_list : false,
      def_props: {},
    };
  },

  created() {
    // Copying default props of all components
    var all_props = {};
    for (var CMP in component_list) {
      var value = component_list[CMP].props.data;
      let key = CMP;
      all_props[key] = value;
    }
    this.def_props = JSON.stringify(all_props);
  },
  methods: {
    /***** DEBUGGER *****/
    hide_options(e) {
      if (e.target.classList.contains("can_hide_options")) {
        let cur_data = {
          type: "",
          uid: null,
        };
        store.commit("make_component_active", cur_data);
      }
    },
    /***** DEBUGGER *****/
    add_page() {
      store.commit("add_page");
    },
    make_page_active(id) {
      store.commit("make_page_active", id);
    },
    add_component(this_type, ref_code) {
      let DP = JSON.parse(this.def_props);
      let this_data;
      let cur_data;
      this_data = DP[ref_code];
      cur_data = {
        type: this_type,
        c_name: ref_code,
        c_data: this_data,
      };
      store.commit("add_component", cur_data);
    },
    make_component_active(this_type, uid) {
      let cur_data = {
        type: this_type,
        uid: uid,
      };
      store.commit("make_component_active", cur_data);
    },
    update_page_name(e) {
      store.commit("update_page_name", e.target.value);
    },
    check_page_name() {
      store.commit("check_page_name");
    },
  },
  computed: {
    /***** DEBUGGER *****/
    state_logger() {
      return JSON.stringify(store.state, null, 2);
    },
    /***** DEBUGGER *****/
    get_pages() {
      return store.state.pages;
    },
    get_active_page() {
      return store.state.general.active_page;
    },
    get_active_component_type() {
      return store.getters.get_active_component_type;
    },
    get_active_component_code() {
      return store.getters.get_active_component_code;
    },
    get_options() {
      return store.getters.get_options;
    },
    allow_page_add() {
      if (store.state.pages.length <= 15) {
        return true;
      } else {
        return false;
      }
    },
    get_page_name() {
      return store.getters.get_page_name;
    },
    check_if_empty() {
      return store.getters.check_if_empty;
    },
  },
};
</script>